import './styles.scss';
import createElement from '../../utils/createElement';
import icelandVideo from '../../../img/iceland.mp4';
import loadVideo from '../../utils/loader';

import Wrap from '../ScreenWrap';

class Screen2 {
    constructor(loader, updateParams){
        this.html = {};
        this.wrap = null;
        this.loader = loader;
        this.updateParams = updateParams;

        this.isFocused = false;
        this.isEntered = false;
        this.isLoaded = false;

        this.videoStopped = false;

        this.ic = 'iceland-content_invisible';

        this.title1Timeout = null;
        this.TITLE1_TIMEOUT = 3000;
        this.lastLoadedPercent = 0;

        this.request = null;
        this.canFlash = true;
        this.hintShown = false;

        this.initListeners = this.initListeners.bind(this);
        this.toBegin = this.toBegin.bind(this);
        this.insertRequest = this.insertRequest.bind(this);
    }

    render(mountNode) {
        this.html.mountNode = mountNode;

        this.html.mainTitle = <h2 class="iceland-content__main-title">
            Ислан
            <br/>
            дия
        </h2>;

        this.html.countryName = <h3 class="iceland-content__country-name">Исландия</h3>;

        this.title1 = <div class="iceland-content__title-1 ">
            <span class="iceland-content__title-1-sub">В</span>тем
            <br/>
            ноте
        </div>;
        this.text1 =
            <div class="iceland-content__text-1">
                Нажми на клавишу
                <br/>
                «Пробел»,
                <br/>
                чтобы получить фото
                <br/>
                в реальном
                времени
            </div>;
        this.flash = <div class="iceland__flash invisible"></div>;
        this.inverseFlash = <div class="iceland__flash-inverse iceland__flash-inverse_base"></div>;
        this.content1 = <div class="iceland-content_1">
            { this.title1 }
            { this.text1 }
        </div>;

        this.content2 = <div class="iceland-content_2">
            { this.title2 = <div class="iceland-content__title-2">Светосильный<br/>объектив</div> }
            { this.text2 = <div class="iceland-content__text-2">
                Технология Dual Pixel.
                <br/>
                Снимайте фото
                <br/>
                даже в условиях
                <br/>
                низкой освещенности
            </div> }
        </div>;

        this.video = <video
            class="iceland__video"
            id="iceland-video"
            autoplay muted
        >
        </video>;

        this.video.playbackRate = 2;

        this.container = <div class="iceland" id="iceland">
            { this.html.countryName }
            { this.html.mainTitle }
            { this.content1 }
            { this.content2 }
            { this.inverseFlash }
            { this.flash }
            { this.video }
        </div>;
        this.wrap = new Wrap(this.container);
        this.wrap.mountTo(this.html.mountNode);
        this.guiState('inactive');
        this.initListeners();
    }


    initListeners(){

        const self = this;
        const can = () => self.isFocused && self.isEntered && self.isLoaded && self.canFlash;

        window.addEventListener('keypress', event => {
            const keyCode = event.keyCode;
            if ((keyCode === 32 || keyCode === 0) && can()) {
                self.canFlash = false;
                self.hintShown = true;
                self.text1.classList.add('invisible');
                self.flash.classList.remove('invisible');
                self.inverseFlash.classList.remove('iceland__flash-inverse_base');
                self.video.pause();
                self.videoStopped = true;
                self.flashTimeout = setTimeout(() => {
                    self.flash.classList.add('invisible');
                    self.guiState('content2');
                }, 0.3 * 1000);
                self.photoTimeout = setTimeout(() => {
                    self.videoStopped = false;
                    self.canFlash = true;
                    self.guiState('nothing');
                    self.video.play();
                    self.inverseFlash.classList.add('iceland__flash-inverse_base');
                }, 3 * 1000);
            }
        }, false);

        this.video.addEventListener('ended', () => {
            if(can()){
                self.video.pause();
                self.intervalRewind = setInterval(() => {
                    if (!self.videoStopped) {
                        self.video.playbackRate = 1.0;
                        if(self.video.currentTime === 0){
                            clearInterval(self.intervalRewind);
                            self.video.play();
                        }
                        else{
                            self.video.currentTime -= 0.025;
                        }
                    }
                }, 1000/60);
            }
        });
    }

    size(heigth, width){
        this.wrap.size(heigth, width);
    }

    focus() {
        this.isFocused = true;
        this.paramsUpdated();
        if( this.isEntered ){
            this.loadVideo();
        }
    }

    paramsUpdated() {
        if (this.isFocused) {
            this.updateParams(this.isFocused, this.isEntered, this.isLoaded);
        }
    }

    unFocus() {
        this.isFocused = false;
        this.paramsUpdated();
        this.toBegin();
    }

    clickEnter() {
        this.isEntered = true;
        this.paramsUpdated();

        if (!this.isLoaded) {
            this.guiState('nothing');
            this.loader.loadStarted(this.lastLoadedPercent);
            this.loadVideo();
        }else {
            this.toBegin();
        }
    }

    preload() {
        loadVideo(
            icelandVideo,
            p => {
                // console.log('iceland', p);
                this.lastLoadedPercent = p;
                if (this.isFocused && this.isEntered) { this.loader.progress(p) }
            },
            0
        ).then(
            video => {
                this.video.src = video;
                if (this.isFocused && this.isEntered) {
                    this.loaded();
                }
            }
        );
    }

    loadVideo() {
        if (this.video.src) {
            this.loaded();
        }
    }

    loaded() {
        const self = this;
        this.isLoaded = true;
        this.paramsUpdated();
        this.loader.loadFinished();
        this.guiState('content1');
        if (this.title1Timeout){
            clearTimeout(this.title1Timeout);
        }
        this.title1Timeout = setTimeout(() => {
            self.title1.style.opacity = 0;
        }, this.TITLE1_TIMEOUT );
    }

    clickExit() {
        this.isEntered = false;
        this.guiState('inactive');
        this.paramsUpdated();
    }

    guiState(state){
        if (this.hintShown) {
            this.text1.style.opacity = 0;
        }
        switch (state){
            case 'inactive':
                this.content1.style.opacity = 0;
                this.content2.style.opacity = 0;
                this.html.mainTitle.style.opacity = 1;
                this.html.countryName.style.opacity = 0;
                this.video.style.opacity = 0;
                break;

            case 'content1':
                this.content1.style.opacity = 1;
                this.content2.style.opacity = 0;
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.video.style.opacity = 1;
                break;

            case 'content2':
                if (this.isEntered && this.isFocused) {
                    ga('s8.send', 'event', 'Iceland', 'final_text');
                }
                this.content1.style.opacity = 0;
                this.content2.style.opacity = 1;
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.video.style.opacity = 1;
                break;

            case 'nothing':
                this.content2.style.opacity = 0;
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.video.style.opacity = 1;
                break;
        }

    }

    toBegin(){
        const self = this;
        if (this.isLoaded && this.isEntered) {
            if (self.title1Timeout){
                clearTimeout(self.title1Timeout);
            }
            setTimeout(() => {
                self.video.currentTime = 0;
                self.video.style.opacity = 0;
                this.guiState('content1');
                if (!this.hintShown) {
                    this.text1.style.opacity = 1;
                }
                this.title1.style.opacity = 1;
                self.inverseFlash.classList.add('iceland__flash-inverse_base');
            }, 200);
            this.title1Timeout = setTimeout(() => {
                self.title1.style.opacity = 0;
            }, this.TITLE1_TIMEOUT );
        }else{
            if (this.request){
                this.request.abort();
            }
            this.loader.loadFinished();
            this.guiState('inactive');
            this.isEntered = false;
            this.updateParams();
        }
    }

    insertRequest(request){
        this.request = request;
    }
}

export default Screen2;


// WEBPACK FOOTER //
// ./src/js/screens/Screen2/index.js